import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchCategoryProduct, useUpdateCategoryProduct } from '@/shared/actions/erp/inventario';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { CATEGORYPRODUCT } from '@/shared/interfaces/erp/inventario';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';

const returnUrl = '/inventario/categoria-productos';

export interface CategoryProductPageInterface {}

const CategoryProductPage: React.FC<CategoryProductPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_categoria_producto)

  const navigate = useNavigate();
  const updSate = useUpdateCategoryProduct({
    enableRedirect: false,
  });
///* global state
const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
const setConfirmDialogIsOpen = useUiConfirmModalStore(
  s => s.setConfirmDialogIsOpen
);
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: categoryProductPagingRes,
    isLoading,
    isRefetching,
  } = useFetchCategoryProduct({
    page: pageIndex + 1,
    nombre: searchTerm,
  });

  ///* mutations


  ///* handlers
  const onEdit = (original: CATEGORYPRODUCT) => {
    navigate(`${returnUrl}/editar/${original.id_categoria_producto}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<CATEGORYPRODUCT>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'numero_referencia',
        size: 300,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },

      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_categoria_producto)) return;

                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de esta categoria ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_categoria_producto!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      }
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Categoria producto" urlRedirect={`${returnUrl}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_categoria_producto)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Categoria del producto" />

      <GeneralTable<CATEGORYPRODUCT>
        columns={columns}
        data={categoryProductPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={categoryProductPagingRes?.data?.count}
        // // actions
        actionsColumnSize={120}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_categoria_producto,
        ])}
        // crud
        onEdit={onEdit}
        canDelete={false}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_categoria_producto,
        ])}
        />
    </SingleTableBoxScene>
  );
};

export default CategoryProductPage;